module.exports = __webpack_public_path__ + "static/img/bg.0ffd59f0.png";